const MotoristasSemNps = ({ dados }) => {
  return (
    <div className="overflow-auto bg-white p-4 rounded shadow">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Motoristas com menos de 5 Avaliações no período</h3>
  
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left px-4 py-2 border">Motorista</th>
              <th className="text-left px-4 py-2 border">Total Pedidos Sem NPS</th>
            </tr>
          </thead>
          <tbody>
            {dados.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-4 py-2 border font-medium">{item.driverId.substring(4)} - {item.driverName}</td>
                <td className="px-4 py-2 border">{item.totalPedidos}</td>
              </tr>
            ))}
            {dados.length === 0 && (
              <tr>
                <td colSpan="2" className="text-center py-4 text-gray-500">
                  Nenhum motorista com pedidos sem NPS no período.
                </td>
              </tr>
            )}
          </tbody>
        </table>
    </div>
  );
};

export default MotoristasSemNps;
